import React from "react";
import { Tabs, Tab, Container } from "react-bootstrap";
import "./CustomTabs.scss";

const CustomTabs = ({
  defaultActiveKey,
  children,
  className = "",
  title = "",
  subtitle = "",
  showContainer = true,
  ...props
}) => {
  const tabsContent = (
    <>
      <Tabs
        defaultActiveKey={defaultActiveKey}
        className={`dashboard-tabs mb-4 mt-3 ${className}`}
        fill
        variant="pills"
        {...props}
      >
        {children}
      </Tabs>
    </>
  );

  return showContainer ? (
    <Container className="dashboard-tabs-container">{tabsContent}</Container>
  ) : (
    <div className="dashboard-tabs-container">{tabsContent}</div>
  );
};

// Export Tab for convenience
export { Tab };
export default CustomTabs;
